// Port of api/fuel/app/classes/insights/hindex/candidates.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'candidates',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: [],
    detail: ['candidates'],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}

        var candidates = []
        var limit = detail ? 100 : 5

        var nextLevel = this._data.current.get_hindex() + 1

        var sorted = Util.query(
            'SELECT p.game_id as g, SUM(p.play_count) AS c, MAX(p.play_date) AS d' +
            ' FROM play p, game g' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.game_id = g.game_id AND g.game_type = 1' +
            this._data.filter + this._data.playFilter +
            ' GROUP BY p.game_id' +
            ' HAVING SUM(p.play_count) < ' + nextLevel +
            ' ORDER BY SUM(p.play_count) DESC, g.game_name ASC' +
            ' LIMIT 0, ' + limit
        )

        for (var i = 0; i < sorted.length; i++) {
            var item = sorted[i]
            candidates.push({
                g: parseInt(item.g, 10),
                c: parseInt(item.c, 10),
                d: parseInt(item.d, 10)
            })
            this._references.games.push(item.g)
        }

        return {
            candidates: candidates
        }

    }
})
